import React from "react";
import Header from "../../components/Header/Header";
import Intro from "../../sections/Intro/Intro";
import Footer from "../../components/Footer/Footer";
import Reviews from "../../sections/Reviews/Reviews";
import Included from "./Included";
import { Link } from "react-router-dom";

const Registration = () => {
  const reviews = [
    {
      text: "Crystal Clear Consulting... made the entire process of setting up and running our business feel effortless... If you want someone who knows exactly what they're doing and makes your life easier setting up and running a business, this is who to go with.",
      author: "Supreme Oil Service",
    },
    {
      text: "Anika... took the time to explain everything clearly, walked me through each step, and made what could have been a stressful process feel simple and manageable. Her professionalism, knowledge, and willingness to help was amazing.",
      author: "Syd and Co.",
    },
  ];
  return (
    <div className="column">
      <Header />
      <Intro
        primary="Register your business correctly."
        secondary="Full-service business registration for entrepreneurs who take compliance seriously."
      />

      <Reviews reviews={reviews} />

      <img
        className="crystals_light crystals_flipped"
        src={require("../../images/crystals_light.png")}
        alt="crystals"
      />

      <Included />

      <div className="container background_light">
        <div className="column w64 g1" style={{ maxWidth: "32rem" }}>
          <h2>Do It Yourself</h2>
          <div className="column g1">
            <p className="ctext">
              If you prefer to register your business on your own, our
              comprehensive guide includes everything you'll need to do.
            </p>
            <Link
              className="link"
              to="/resources/new-business-registration-checklist"
            >
              View the checklist
            </Link>
          </div>
        </div>
      </div>

      <Footer background />
    </div>
  );
};

export default Registration;
